import shiftRequestDetailsStore from "../../store/store";
import { IBaseShiftEntity } from "sh-models";
import { mutatorAction } from "satcheljs";

export default mutatorAction('SET_OTHER_SHIFT', function setOtherShiftInStore(otherShift: IBaseShiftEntity) {
    if (shiftRequestDetailsStore) {
        shiftRequestDetailsStore.otherShift = otherShift;
    }
});
